export default function defer(fn) {
  return setTimeout(fn, 0);
};